module.exports = __webpack_public_path__ + "img/15.4ac9465f.webp";